import { QueryKey } from '@tanstack/react-query';

const baseKey: QueryKey = ['credits'] as const;

export const creditsQueryKeys = {
  base: baseKey,
  getCredits: [...baseKey, 'get'],
  updateCredits: [...baseKey, 'updateCredits'],
} as const;
